<template>
  <div>

    <div class="row  mt-3">
      <div class="col-12 mt-3">
      </div>

      <div class="col-sm-12 col-lg-12 col mt-3 ">

        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table w-100">
                <tbody>
                <tr v-if="job.status === 'finished' && (getClaims.admin || getClaims.teamlead)">
                  <td colspan="2">
                    <button class="btn btn-danger btn-block" @click="setJobUnfinished()">{{
                      $t('jobs.detail.restartJob')
                      }}
                    </button>
                  </td>
                </tr>
                <tr>

                  <td><strong>{{ $t('jobs.detail.progress') }}</strong></td>
                  <td>
                    <div class="progress">
                      <div class="progress-bar" role="progressbar"
                        :class="getJobProgress(job.id).percentage >= 100 ? 'bg-success' : ''"
                        :style="'width:' + getJobProgress(job.id).percentage + '%'"
                        :aria-valuenow="' + getJobProgress(job.id).amountProduced + '" aria-valuemin="0"
                        :aria-valuemax="' + getJobProgress(job.id).amount + '"></div>
                    </div>
                  </td>
                </tr>

                <tr v-if="getFinishedDate() ">
                  <td><strong>FinishedDate</strong></td>
                  <td>{{ getFinishedDate() }}</td>
                </tr>
                <tr v-if="job.predictedNetTimeSpent">
                  <td><strong>Predicted Net Time spent</strong></td>
                  <td>{{ formattedColonTime(job.predictedNetTimeSpent) }}</td>
                </tr>
                <tr v-if="job.predictedGrossTimeSpent ">
                  <td><strong>Predicted Gross Time Spent</strong></td>
                  <td>{{ formattedColonTime(job.predictedGrossTimeSpent) }}</td>
                </tr>
                <tr>
                  <td><strong>{{ $t('downTimes.totalDownTime') }}</strong></td>
                  <td> {{ formattedColonTime(getJobTotalDownTime(job.id)) }}</td>

                </tr>
                <tr v-if="job.npc && job.npcMeta">
                  <td><strong>NPC</strong></td>
                  <td> {{ getFormattedNPC(job) }}</td>

                </tr>
                  <template v-for="(value, idx) in JobDetailsData">
                    <tr :key="idx" v-if="value.value">
                      <td><strong>{{ getPropertyName(value.label) }}</strong></td>
                      <td>{{ typeFormat(value.value) }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
    <JobProductAmounts :job="job" />
  </div>

</template>

<script>
import {mapGetters} from 'vuex';
//mixins
import timeCalc from '../../mixins/timeCalc';
import JobProductAmounts from './JobProductAmounts.vue';
import { typeFormat } from '@/filters/filters';
// @vuese
// @group Job
// This component shows the Job details from Job passed as prop. General job information and job progress if an defaultProgressKpi is set in the company in firebase
export default {
  name: 'JobDetail',
  components: { JobProductAmounts },

  mixins: [timeCalc],
  props: {
    //@vuese
    // The job to show details from
    job: {
      required: true,
      type: Object,
      default: null
    }
  },
  data() {
    return {
      comment: {
        remark: {
          text: null,
          by: []
        },
        suggestion: {
          text: null,
          by: []
        }
      },
      localProductConfig: null
    };
  },
  computed: {
    ...mapGetters('users', [
      'getClaims'
    ]),
    ...mapGetters('jobs', [
      'getJobProgress',
      'getJobDetail',
      'getFormattedNPC',
      'getJobTotalDownTime',
      'getJobDetailWithProduct'
    ]),
    ...mapGetters('products', ['getProductByField']),
    JobDetailsData(){
      return this.getJobDetailWithProduct(this.job, this.localProductConfig)
    },
    // @vuese
    // Get job details about the numbers this job totally produced.
    //`{target:0,timeSpent:0,amount:0,amountProduced:0}`
    // @type  Object
    getJobNumbers() {
      let jobDetails = _.clone(this.job);
      return {
        target: jobDetails.target,
        timeSpent: jobDetails.timeSpent,
        amount: jobDetails.amount,
        amountProduced: jobDetails.amountProduced
      };
    },
  },
  methods: {
    typeFormat,
    //@vuese
    // Converts key to Key
    getPropertyName(value) {
      return _.startCase(value);
    },
    getFinishedDate() {
      try {
        let format = 'DD/MM/YY';
        return moment(this.job.finishedDate.toDate()).utc().format(format);
      } catch (e) {

      }
    },
    //@vuese
    // returns value and if its a date and has toDate function it returns formatted time
    getValueType(data) {
      if (typeof data == 'object' && Object.getPrototypeOf(data).hasOwnProperty('toDate')) {
        let format = 'DD/MM/YY';
        return moment(data.toDate()).utc().format(format);
      } else {

        if (typeof data == 'number') {
          return data.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }

        return data;
      }
    },
    //@vuese
    // This will reset the job to unfinished and removes the status, finished Date and finished by keys
    // This is only usable by admins at this time.
    setJobUnfinished() {
      return this.$swal({
        title: this.$t('jobs.detail.restartModal.title'),
        text: this.$t('jobs.detail.restartModal.text'),
        showConfirmButton: true,
        showCancelButton: true,
      }).then(async res => {
        if (res.value) {
          await this.$store.dispatch('jobs/patch', {
            id: this.job.id,
            status: this.$FBClient.firestore.FieldValue.delete(),
            finishedDate: this.$FBClient.firestore.FieldValue.delete(),
            finishedBy: this.$FBClient.firestore.FieldValue.delete()
          })
          location.reload()

        }
      })
    }
  },
  async created() {
    let where = [
      ['companyId', '==', this.getClaims.companyId],
    ]
    await this.$store.dispatch('products/openDBChannel', { where })
    this.localProductConfig = this.getProductByField('productNumber', this.job.productNumber)
  }
};
</script>

<style scoped lang="scss">
tr:first-child td {
  border-top: 0;
}

::v-deep .card {
  background-color: #fff !important;
  color: #333 !important;
  border: 1px solid rgba(0, 0, 0, 0.125);
}

::v-deep .card-body {
  color: #333 !important;
}

::v-deep .table {
  color: #333 !important;
  background-color: transparent;

  td, th {
    color: #333 !important;
    border-top: 1px solid #dee2e6;
  }

  strong {
    color: #333 !important;
  }
}

.progress {
  background-color: white;
  height: 2rem;
}

.progress-bar {
  background-color: #00c9ff;
}
</style>
